/**
 * -----------------------------------------------------------------------------
 * This renders the sign out password form
 */
export function SignOutForm() {
  return <div>Forgot Password Form</div>;
}
